import React, { useContext, useState } from 'react';
import { T, useTranslate } from '@tolgee/react';
import {
	SypacButton,
	SypacCheckbox,
	SypacIcon,
	SypacText,
} from '@sypac/component-library-react';
import Close from '../../../../assets/Close';
import { useNavigate } from 'react-router-dom';
import Flag from 'react-world-flags';
import { StepProps } from '../addNewProduct.interface';
import {
	ProductContext,
	ProductProps,
} from '../../../../context/DatabaseProductContext/database-product.context';

const ProductStoreStep: React.FC<StepProps> = ({ setStep }) => {
	const { t } = useTranslate();
	const navigate = useNavigate();
	const { product, setProduct } = useContext(ProductContext);
	const [selectedCountry, setSelectedCountry] = useState<string | null>(null);

	const countries = [
		{ key: 'POL', label: t('adminProducts.poland', 'Poland'), flag: 'PL' },
		{
			key: 'MDA',
			label: t('adminProducts.moldova', 'Moldova'),
			flag: 'MD',
		},
	];

	const handleCountrySelect = (countryKey: string) => {
		setSelectedCountry(countryKey === selectedCountry ? null : countryKey);
	};

	const handleNextStep = () => {
		if (selectedCountry) {
			setProduct({
				...product,
				countryCode: selectedCountry,
			} as ProductProps);

			setStep((prevStep) => prevStep + 1);
		}
	};

	const renderCountries = (item: {
		key: string;
		label: string;
		flag: string;
	}) => {
		return (
			<div
				key={item.key}
				className={`flex gap-3 items-center px-3 py-[17px] border border-solid border-gray-10 rounded-xl cursor-pointer transition hover:border-gray-40 ${
					selectedCountry === item.key ? 'border-primary-violet' : ''
				}`}
				onClick={() => handleCountrySelect(item.key)}
			>
				<SypacCheckbox size="md">
					<input
						type="checkbox"
						className="cursor-pointer"
						checked={selectedCountry === item.key}
						onChange={() => handleCountrySelect(item.key)}
					/>
				</SypacCheckbox>

				<div className="flex gap-3 mt-1">
					<Flag
						className="mb-[2px] object-cover border border-solid border-gray-10 rounded mt-[1px]"
						code={item.flag}
						width={20}
						height={14}
					/>
					<SypacText variant="body-regular-medium">
						<p>{item.label}</p>
					</SypacText>
				</div>
				{item.key === 'POL' && (
					<SypacIcon
						iconName="Crown Minimalistic"
						className="text-texas-rose"
						size="custom"
						width="24px"
						height="24px"
					/>
				)}
			</div>
		);
	};

	return (
		<div className="w-full h-full flex items-center justify-center">
			<main className="max-w-[486px] w-full flex flex-col gap-6">
				<section className="flex justify-between items-center">
					<SypacText variant="body-normal-medium">
						<p className="text-xl text-gray-80">
							<T keyName="productGroup.manageProduct">
								Manage product groups and categories
							</T>
						</p>
					</SypacText>
					<SypacButton variant="secondary" size="medium">
						<button
							onClick={() => navigate('/product-database')}
							className="p-2 border border-solid border-gray-10 transition hover:border-primary-violet"
						>
							<Close />
						</button>
					</SypacButton>
				</section>

				<SypacText variant="body-normal-medium">
					<p className="text-gray-60">
						<T keyName="selectProductStore.selectCountryStore">
							Select country store
						</T>
					</p>
				</SypacText>
				<div className="border-0 border-solid border-t-[1px] border-gray-10" />

				<div>
					<div className="flex flex-col gap-3 p-3 border border-solid border-gray-10 rounded-xl shadow-dropdown-avatar">
						{countries?.map((item) => renderCountries(item))}
					</div>
					<nav className="flex justify-center w-full mt-[40px] gap-3">
						<SypacButton variant="secondary" size="small" className="w-full">
							<button
								type="button"
								className="w-full px-6 py-[10px] rounded-lg"
								onClick={() => navigate(-1)}
							>
								<SypacText variant="body-regular-medium">
									<p>
										<T keyName="companyDetails.back">Back</T>
									</p>
								</SypacText>
							</button>
						</SypacButton>
						<SypacButton variant="primary" size="small" className="w-full">
							<button
								type="button"
								className="w-full px-6 py-[11px] rounded-lg"
								onClick={handleNextStep}
								disabled={!selectedCountry}
							>
								<SypacText
									variant="body-regular-medium"
									className="flex items-center gap-4"
								>
									<p>
										<T keyName="clientSelectQuantity.next">Next</T>
									</p>
								</SypacText>
							</button>
						</SypacButton>
					</nav>
				</div>
			</main>
		</div>
	);
};
export default ProductStoreStep;
